
if (!customElements.get('ces-2025-tab-scroll-products')) {
  class Ces2025TabScrollProducts extends HTMLElement {
    slideLock = false;
    tempSpeed;
    dialogOpened = false;

    constructor() {
      super();
      this.swiperContainer = this.querySelector('.swiper');
      this.autoplay = this.getAttribute('data-swiper-autoplay') == 'true';
      this.reverseDirection = this.getAttribute('data-swiper-reverse') == 'true';
      this.speed = Number(this.getAttribute('data-swiper-speed'));
      if (isNaN(this.speed)) {
        this.speed = 40000;
      } else {
        this.speed = this.speed * 1000;
      }
      this.tempSpeed = this.speed;
      this.tabs = this.querySelectorAll('.ces-2025-tab-scroll-products__bottom-tabs li');
      this.dialogs = this.querySelectorAll('[data-klaviyo-dialog]');
      this.dialogCloseButtons = this.querySelectorAll('[data-close-klaviyo-dialog]');

      this.initSwiper();
      this.initTab();
      this.initDialog();

      const items = this.querySelectorAll('.ces-2025-tab-scroll-products__item-image');
      for (const item of items) {
        const video = this.querySelector('.ces-2025-tab-scroll-products__item-image-video-hover');
        if (video) {
          item.addEventListener('mouseenter', () => {
            video.play();
          });
          item.addEventListener('mouseleave', () => {
            video.pause();
          });
        }
      }
    }

    initSwiper() {
      this.mySwiper = new Swiper(this.swiperContainer, {
        slidesPerView: 'auto',
        spaceBetween: 0,
        // normalizeSlideIndex: false,
        centeredSlides: true,
        loop: true,
        // loopedSlides: 5,
        freeMode: true,
        centeredSlides: true,
        grabCursor: true,
        // updateOnWindowResize: true,
        autoplay: this.autoplay ? {
          delay: 0,
          disableOnInteraction: false,
        } : false,
        speed: this.speed,
        observer: true,
        observeParents: true,
        on: {
          slideChangeTransitionEnd: () => this.handleSlideChanged(),
        },
      });
      // autoplay pause if version < 6.6.2
      if (this.autoplay) {
        const mySwiper = this.mySwiper;
        mySwiper.setTranslate(mySwiper.getTranslate());
        mySwiper.el.onmouseenter = this.mouseEnter.bind(this);
        mySwiper.el.onmouseleave = this.mouseLeave.bind(this);
        window.addEventListener('resize', function () {
          mySwiper.autoplay.start();
        })
      }
    }

    initTab() {
      for (const tab of this.tabs) {
        tab.addEventListener('click', () => {
          if (this.slideLock) return;
          const tabName = tab.getAttribute('data-tab-name');
          const selector = `.swiper-slide[data-for-tab="${tabName}"]:not(.swiper-slide-duplicate)`;
          const findSlide = this.querySelector(selector);
          if (!findSlide) {
            console.warn("Selector not found: ", selector, findSlide);
            return;
          }
          const index = Number(findSlide.getAttribute('data-swiper-slide-index'));
          if (isNaN(index)) {
            console.error("Index is NaN, ", "data-swiper-slide-index");
            return;
          }
          this.slideLock = true;
          if (index == this.mySwiper.realIndex) {
            this.mySwiper.translateTo(this.mySwiper.translate - 1, 800)
          } else {
            this.mySwiper.slideToLoop(index, 800);
          }
          setTimeout(() => {
            this.slideLock = false;
          }, 800);
        });
      }
    }

    initDialog() {
      // for (const dialogButton of this.dialogButtons) {
      //   dialogButton.addEventListener('click', () => {
      //     const dialogId = dialogButton.getAttribute('data-button-klaviyo-dialog');
      //     for (const dialog of this.dialogs) {
      //       if (dialog.getAttribute('data-klaviyo-dialog') == dialogId) {
      //         this.openDialog(dialogId);
      //       }
      //     }
      //   });
      // }
      this.dialogs = this.querySelectorAll('[data-klaviyo-dialog]');
      for (const closeButton of this.dialogCloseButtons) {
        closeButton.addEventListener('click', this.closeDialog.bind(this));
      }
    }

    handleSlideChanged() {
      if (this.mySwiper) {
        const currentSlide = this.mySwiper.slides[this.mySwiper.activeIndex];
        const forTab = currentSlide.getAttribute('data-for-tab');
        if (!forTab) return;
        for (const tab of this.tabs) {
          if (tab.getAttribute('data-tab-name') == forTab) {
            tab.classList.add('active');
          } else if (tab.classList.contains('active')) {
            tab.classList.remove('active');
          }
        }
      }
    }

    mouseEnter() {
      const mySwiper = this.mySwiper;
      const currentWidth = mySwiper.slides[mySwiper.activeIndex].offsetWidth;
      this.tempSpeed = (Math.abs(Math.abs(mySwiper.translate) - Math.abs(mySwiper.getTranslate())) / currentWidth) * this.speed;
      if (Math.floor(this.tempSpeed * 100) / 100) {
        this.tempSpeed = Math.floor(this.tempSpeed * 100) / 100;
      }
      mySwiper.autoplay.stop();
      mySwiper.translateTo(mySwiper.getTranslate(), 0);
    }

    mouseLeave() {
      if (this.dialogOpened) return;
      const mySwiper = this.mySwiper;
      mySwiper.slideTo(mySwiper.activeIndex, this.tempSpeed);
      mySwiper.autoplay.start();
    }

    openDialog(dialogId) {
      const dialog = this.querySelector(`[data-klaviyo-dialog="${dialogId}"]`);
      if (!dialog) {
        console.warn(`Element of selctor: [data-klaviyo-dialog="${dialogId}"] not found`);
        return;
      }
      this.dialogOpened = true;
      dialog.classList.add('active');
      setTimeout(() => {
        this.mouseEnter();
      }, 1);
    }

    closeDialog() {
      this.dialogOpened = false;
      for (const dialog of this.querySelectorAll('[data-klaviyo-dialog].active')) {
        dialog.classList.remove('active');
      }
      this.mouseLeave();
    }
  }
  customElements.define('ces-2025-tab-scroll-products', Ces2025TabScrollProducts);
}

if (!customElements.get('ces-2025-tab-scroll-products-dialog-button')) {
  class Ces2025TabScrollProductsDialogButton extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('ces-2025-tab-scroll-products');

      this.addEventListener('click', () => {
        const dialogId = this.getAttribute('data-button-klaviyo-dialog');
        if (dialogId != null && dialogId != '') {
          this.section.openDialog(dialogId);
        }
      });
    }
  }
  customElements.define('ces-2025-tab-scroll-products-dialog-button', Ces2025TabScrollProductsDialogButton);
}